import { generateID } from '@caresend/utils';
import { getCloudPublicKey } from './keys.js';
import { encrypt, encryptBlob } from './utils/client.js';

/**
 * Encrypt any given data
 * @param data Data that needs to be encrypted
 * @param accessAttributes Attributes of users with access to encrypted data
 * @param accessAttributes Attributes of users with access to encrypted data
 * @return {Promise<EncryptedData<T>>}
 */
const encryptDataWithRootState = async (data, rootState, inputAccessAttributes) => {
    var _a, _b;
    const { key: cloudKey, version } = await getCloudPublicKey();
    const userID = (_b = (_a = rootState.auth.user) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : '';
    const accessAttributes = inputAccessAttributes !== null && inputAccessAttributes !== void 0 ? inputAccessAttributes : [];
    accessAttributes.push({ userID });
    const rawData = { data, accessAttributes };
    const encrypted = await encrypt(rawData, cloudKey);
    const encryptedData = {
        data: encrypted,
        encrypted: true,
        id: generateID(),
        keyVersion: version,
        timestamp: Date.now(),
    };
    return encryptedData;
};
/**
 * Encrypt any file
 * @param inputFile File to encrypt
 * @param metadata Decrypted file metadata (for later reconstruction)
 * @param uploadAction Function to upload blob and resolve a data URL
 * @param accessAttributes Attributes of users with access to encrypted data
 * @return {Promise<EncryptedFile>} Encrypted File object
 */
const encryptFileWithRootState = async (inputFile, metadata, uploadAction, rootState, inputAccessAttributes) => {
    const { blob, key } = await encryptBlob(inputFile);
    const encryptedKey = await encryptDataWithRootState(key, rootState, inputAccessAttributes);
    const dataURL = await uploadAction(blob);
    const encryptedFile = {
        key: encryptedKey,
        dataURL,
        timestamp: Date.now(),
        id: generateID(),
        encryptedFile: true,
        metadata,
    };
    return encryptedFile;
};

export { encryptDataWithRootState, encryptFileWithRootState };
